import { render, staticRenderFns } from "./GestaoFrotaContainer.vue?vue&type=template&id=4f89ee6a&scoped=true"
import script from "./GestaoFrotaContainer.vue?vue&type=script&lang=js"
export * from "./GestaoFrotaContainer.vue?vue&type=script&lang=js"
import style0 from "./GestaoFrotaContainer.vue?vue&type=style&index=0&id=4f89ee6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89ee6a",
  null
  
)

export default component.exports